import {
  AddressDataDto,
  AssetsInfoDto,
  AssetsLimitDto,
  HouseholdMemberDto,
  IncomeInfoDto
} from "homey-housing-lottery-app-dto";
import {formatCurrency} from "@angular/common";

export const formatAddressLines = (address: AddressDataDto | undefined): string[] | undefined => {
  if (!address) {
    return undefined;
  }

  const apartment = address.apartment ? `, ${address.apartment}` : '';
  const line1 = `${address.address}${apartment}`;
  const line2 = `${address.city}, ${address.state} ${address.zip}`;

  return [line1, line2];
};

export const formatMoney = (value: number): string => {
  return formatCurrency(value, 'en-US', '$', 'USD', '1.0-0');
};

export const getTotalIncome = (income: IncomeInfoDto): number => {
  return income.employment + income.selfEmployment + income.governmentBenefits + income.retirementDisability + income.other;
};

export const getAssetsInfoTotal = (assets: AssetsInfoDto): number => {
  return assets.checking + assets.savings + assets.retirement + assets.brokerage + assets.investment + assets.realEstate;
};

export const getHouseholdMembersAssetsTotal = (members: HouseholdMemberDto[]): number => {
  return members.reduce((sum, member) => sum + getAssetsInfoTotal(member.assets), 0);
};

export const getAssetsLimitLabel = (limit: AssetsLimitDto): string => {
  switch (limit) {
    case 'greater-than-5k':
      return 'Less than yearly income';
    case 'smaller-than-5k':
      return 'Less than $5,000';
    case 'greater-than-x-times-income':
      return 'More than 1.8× household income';
  }
};

